document.addEventListener("DOMContentLoaded", function() {
  var toggleBtn = document.getElementById("toggle-description");
  var shortDesc = document.getElementById("short-description");
  var fullDesc = document.getElementById("full-description");

  toggleBtn.addEventListener("click", function() {
    if (fullDesc.style.display === "none") {
      shortDesc.style.display = "none";
      fullDesc.style.display = "block";
      toggleBtn.textContent = "Read Less";
    } else {
      shortDesc.style.display = "block";
      fullDesc.style.display = "none";
      toggleBtn.textContent = "Read More";
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var quantityDiv = document.querySelector('.product-form__quantity');
  
  if (quantityDiv && quantityDiv.nextElementSibling) {
    var nextDiv = quantityDiv.nextElementSibling;

    // Create wrapper div
    var wrapper = document.createElement('div');
    wrapper.classList.add('quantity-and-cart-both-sr');

    // Insert wrapper before quantityDiv
    quantityDiv.parentNode.insertBefore(wrapper, quantityDiv);

    // Move both elements inside wrapper
    wrapper.appendChild(quantityDiv);
    wrapper.appendChild(nextDiv);
  }
});

/* Put in assets/theme.js (or before </body>) */
(function () {
  const TARGET_SELECTOR = '.our_fabric_bottom_set'; // <- apna section selector

  const slug = (v) => (v || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');

  function applyColorClass(root = document) {
    const targets = root.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return;

    // Find selected color (radios or select)
    const radioChecked =
      root.querySelector('input[type="radio"][name="Color-1"]:checked') ||
      root.querySelector('input[type="radio"][name^="Color"]:checked');

    const selectEl =
      root.querySelector('select[name="Color-1"]') ||
      root.querySelector('select[name^="options"]');

    let value = '';
    if (radioChecked) value = radioChecked.value;
    else if (selectEl) value = selectEl.value || selectEl.options?.[selectEl.selectedIndex]?.text;

    targets.forEach((el) => {
      // remove any previous color-* class
      [...el.classList].forEach((cls) => {
        if (cls.startsWith('color-')) el.classList.remove(cls);
      });
      if (value) el.classList.add(`color-${slug(value)}`);
    });
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', () => applyColorClass());

  // React to user changes (works even if radios get re-rendered)
  document.addEventListener('change', (e) => {
    if (
      e.target.matches(
        'input[type="radio"][name="Color-1"], input[type="radio"][name^="Color"], select[name="Color-1"], select[name^="options"]'
      )
    ) {
      applyColorClass();
    }
  });

  // Re-bind after Shopify replaces a section via AJAX
  document.addEventListener('shopify:section:load', (e) => applyColorClass(e.target));
})();



  (function(){
    const tabButtons = document.querySelectorAll('.size-tabs__btn');
    const panels = document.querySelectorAll('.size-tabs__panel');

    function activate(key){
      // buttons
      tabButtons.forEach(b=>{
        b.classList.toggle('is-active', b.dataset.tab === key);
        b.setAttribute('aria-selected', b.dataset.tab === key ? 'true' : 'false');
        b.setAttribute('tabindex', b.dataset.tab === key ? '0' : '-1');
      });
      // panels
      panels.forEach(p=>{
        p.classList.toggle('is-active', p.id === 'panel-' + key);
        p.hidden = p.id !== 'panel-' + key;
      });
    }

    // click
    tabButtons.forEach(b=> b.addEventListener('click', ()=> activate(b.dataset.tab)));

    // default: 3rd tab active
    activate('duvet');
  })();

/* document.addEventListener("DOMContentLoaded", function() {
  function updateGalleryByVariant(variantName) {
    const galleryItems = document.querySelectorAll('.product__media-item');
    if (!galleryItems.length) return;

    let found = false;

    galleryItems.forEach(item => {
      const img = item.querySelector('img');
      if (img && img.alt && img.alt.toLowerCase().includes(variantName.toLowerCase())) {
        item.style.display = "block"; // show matched
        found = true;
      } else {
        item.style.display = "none";  // hide unmatched
      }
    });

    // Fallback: if nothing matched, show all
    if (!found) {
      galleryItems.forEach(item => {
        item.style.display = "block";
      });
    }
  }

  // Attach event to swatches
  function attachSwatchListeners() {
    const variantSwatches = document.querySelectorAll('.product-form__input input[type="radio"]');
    if (!variantSwatches.length) return;

    variantSwatches.forEach(swatch => {
      swatch.addEventListener("change", function() {
        if (this.checked) {
          updateGalleryByVariant(this.value);
        }
      });
    });

    // On page load, update initial
    const checkedSwatch = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (checkedSwatch) {
      updateGalleryByVariant(checkedSwatch.value);
    }
  }

  // Run once
  attachSwatchListeners();

  // 🔹 Handle Dawn's variant change event
  document.addEventListener('variant:change', function(evt) {
    if (evt.detail && evt.detail.variant) {
      updateGalleryByVariant(evt.detail.variant.title);
    }
  });

  // 🔹 Fallback: observe DOM changes (if Dawn re-renders)
  const observer = new MutationObserver(() => {
    attachSwatchListeners();
  });
  const formWrapper = document.querySelector(".product");
      if (formWrapper) {
        observer.observe(formWrapper, { childList: true, subtree: true });
      }
});

/* document.addEventListener("DOMContentLoaded", function () {
  const productTitleEl = document.querySelector(".product__title h1");
  if (!productTitleEl) return;

  function getBaseTitle() {
    return productTitleEl.textContent.split(" - ")[0].replace(/\(.*?\)/, "").trim();
  }

  function cleanVariantName(variantName) {
    if (!variantName) return "";
    variantName = variantName.replace(/\band\b/gi, "").trim();
    variantName = variantName.replace(/\bwhite\b/gi, "").trim();
    variantName = variantName.replace(/\s+/g, " ");
    return `(${variantName})`;
  }

  function updateProductTitle(variantName) {
    const baseTitle = getBaseTitle();
    if (!variantName) {
      productTitleEl.textContent = baseTitle;
    } else {
      productTitleEl.textContent = `${baseTitle} ${cleanVariantName(variantName)}`;
    }
  }

  function handleTitleChange(value) {
    updateProductTitle(value);
    setTimeout(() => updateProductTitle(value), 1000); // ensure after 1 sec
  }

  // Event delegation for radio buttons
  document.body.addEventListener("change", function (e) {
    const target = e.target;
    if (target.matches('.product-form__input input[type="radio"]') && target.checked) {
      handleTitleChange(target.value);
    } else if (target.matches('.product-form__input select')) {
      handleTitleChange(target.value);
    }
  });

  // Initial check on page load
  const checkedSwatch = document.querySelector('.product-form__input input[type="radio"]:checked');
  if (checkedSwatch) {
    handleTitleChange(checkedSwatch.value);
  } else {
    const selectEl = document.querySelector('.product-form__input select');
    if (selectEl) handleTitleChange(selectEl.value);
  }

  // Dawn theme variant:change event
  document.addEventListener('variant:change', function(evt) {
    if (evt.detail && evt.detail.variant) {
      handleTitleChange(evt.detail.variant.title);
    }
  });
}); */




